import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ApplicationService } from './api/application.service';
import { AuthlessTokenService } from './api/authlessToken.service';
import { ConversationService } from './api/conversation.service';
import { InvitationService } from './api/invitation.service';
import { MessageService } from './api/message.service';
import { PublicConversationService } from './api/publicConversation.service';
import { PublicMessageService } from './api/publicMessage.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    ApplicationService,
    AuthlessTokenService,
    ConversationService,
    InvitationService,
    MessageService,
    PublicConversationService,
    PublicMessageService,
  ],
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
